import Vue from 'vue';
import Api from '@/config/api';

export default {
  state: {
    // profile: {
    //   full_name: '',
    //   last_name: '',
    //   furigana: '',
    //   last_furigana: '',
    //   email: '',
    //   birth_date: '',
    //   residence: '',
    //   final_education: '',
    //   graduation_school_name: '',
    //   graduation_department_name: '',
    //   year_of_graduation: '',
    //   recent_registered_company_name: '',
    //   // years_of_attendance: '',
    //   latest_occupation_main_title: '',
    //   latest_occupation_sub_title: '',
    //   employment_status: '',
    //   position: '',
    //   english_skills: '',
    //   last_year_income: '',
    //   number_of_experience_companies: '',
    //   job_summary: '',
    //   // phone: '',
    //   resume:'',
    //   file_name:'',
    //   selectedFile:'',
    //   events:[],
    //   cv:'',
    //   cv_file_name:'',
    //   cv_selectedFile:'',
    //   currently_enrolled: undefined,
    //   enrollment_period_from: "/",
    //   enrollment_period_to: "/",
    // },
    profile: {},
    companies: [],
    selectBoxValues: [],
    allEvents: [],
    priorityCompanies: [],
  },
  getters: {
    getProfile(state) {
      return state.profile;
    },
    getAllEvents(state) {
      return state.allEvents;
    },
    getPriorityCompanies(state) {
      return state.priorityCompanies;
    },
    getCompanies(state) {
      return state.companies;
    },
    getSelectBoxValues(state) {
      return state.selectBoxValues;
    },
  },
  mutations: {
    setProfile(state, data) {
      // eslint-disable-next-line
      state.profile = data;
    },
    setAllEvents(state, data) {
      state.allEvents = data;
    },
    setPriorityCompanies(state, data) {
      state.priorityCompanies = data;
    },
    setCompanies(state, data) {
      state.companies = data;
    },
    setSelectBoxItems(state, data) {
      state.selectBoxValues = data;
    },
    changeEmail(state, data) {
      const newEmail = data;
      state.profile.email = newEmail;
    },
    clearAll(state) {
      state.profile = {};
      state.companies = [],
      state.selectBoxValues = [],
      state.allEvents = [],
      state.priorityCompanies = [];
    },
  },
  actions: {
    async setProfile({ commit }) {
      const token = await Vue.auth.getToken();
      try {
        const profile = await Vue.axios({
          method: 'get',
          url: Api.url(Api.endpoints.profile),
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        // console.log(profile.data.data);
        commit('setProfile', profile.data.data);
      } catch (error) {
        console.log(error);
        Vue.auth.logout();
      }
    },
    async setAllEvents({ commit }) {
      const token = await Vue.auth.getToken();
      try {
        const events = await Vue.axios({
          method: 'get',
          url: Api.url(`${Api.endpoints.events}`),
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        commit('setAllEvents', events.data);
      } catch (err) {
        console.log(err);
      }
    },
    async loadPriorityCompanies({ commit }) {
      const token = await Vue.auth.getToken();
      try {
        const companies = await Vue.axios({
          method: 'get',
          url: Api.url(`${Api.endpoints.priorityCompanies}`),
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const priorityCompanies = companies.data.map(company => company._id);
        commit('setPriorityCompanies', priorityCompanies);
      } catch (err) {
        console.log(err);
      }
    },
    async companiesList({ commit }) {
      const token = await Vue.auth.getToken();
      try {
        const response = await Vue.axios({
          method: 'get',
          url: Api.url(`${Api.endpoints.companies}`),
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        commit('setCompanies', response.data.data.companies);
      } catch (err) {
        console.log(err);
      }
    },
    async selectBoxValues({ commit }) {
      const token = await Vue.auth.getToken();
      try {
        const response = await Vue.axios({
          method: 'get',
          url: Api.url(`${Api.endpoints.selectBoxValues}`),
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        commit('setSelectBoxItems', response.data.data);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
